import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius, font } from '~styles/theme.stylex';
export const styles = {
  card: {
    backgroundColor: "x80m72e",
    borderRadius: "xdkhd45",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    marginBottom: "xyi6m4r",
    $$css: true
  },
  row: {
    display: "x78zum5",
    alignItems: "x1cy8zhl",
    gap: "x1fsutb",
    rowGap: null,
    columnGap: null,
    paddingInline: "xnxx81d",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: "x142x9wm",
    paddingTop: null,
    paddingBottom: null,
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    color: "x1heor9g",
    $$css: true
  },
  whereButton: {
    width: "xh8yej3",
    background: "x11g6tue",
    backgroundAttachment: null,
    backgroundClip: null,
    backgroundColor: null,
    backgroundImage: null,
    backgroundOrigin: null,
    backgroundPosition: null,
    backgroundPositionX: null,
    backgroundPositionY: null,
    backgroundRepeat: null,
    backgroundSize: null,
    border: "x1gs6z28",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    font: "xln7xf2",
    fontFamily: null,
    fontSize: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontVariantAlternates: null,
    fontVariantCaps: null,
    fontVariantEastAsian: null,
    fontVariantEmoji: null,
    fontVariantLigatures: null,
    fontVariantNumeric: null,
    fontVariantPosition: null,
    fontWeight: null,
    lineHeight: null,
    textAlign: "xdpxx8g",
    cursor: "x1ypdohk",
    $$css: true
  },
  iconWhen: {
    color: "x1n9cmz0",
    flexShrink: "x2lah0s",
    marginTop: "x72edsj",
    $$css: true
  },
  iconWhere: {
    color: "xm6zed8",
    flexShrink: "x2lah0s",
    marginTop: "x72edsj",
    $$css: true
  },
  col: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    minWidth: "xeuugli",
    flex: "x98rzlu",
    flexGrow: null,
    flexShrink: null,
    flexBasis: null,
    $$css: true
  },
  label: {
    fontSize: "xboafo0",
    fontWeight: "x1sl8krj",
    letterSpacing: "x2ujxvm",
    textTransform: "xtvhhri",
    color: "xarw3lm",
    $$css: true
  },
  value: {
    fontSize: "x1jchvi3",
    fontWeight: "xlr2uoh",
    color: "xtt1gjl",
    marginTop: "x72edsj",
    $$css: true
  },
  subtitle: {
    fontSize: "x1dcheo9",
    color: "xarw3lm",
    marginTop: "x72edsj",
    $$css: true
  },
  divider: {
    height: "xjm9jq1",
    backgroundColor: "x1h40hdj",
    marginInline: "x1nqqfzk",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  },
  chevron: {
    color: "x1gonuu0",
    flexShrink: "x2lah0s",
    alignSelf: "xamitd3",
    $$css: true
  }
};